/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from '@app/app/shared/helpers/dialog/dialog.service';
import { ReportSection, UpdateReportFeedbackProvidersRequest } from '@app/app/shared/models';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'ptl-feedback-providers-report-section',
  templateUrl: './feedback-providers-section.component.html',
  styleUrls: [
    './feedback-providers-section.component.scss',
    '../../../view/diagnostics-view-report/feedback/providers-section/providers-section.component.scss',
  ],
})
export class FeedbackProvidersSectionComponent {
  @Input() section: ReportSection;

  @Output() moveUp = new EventEmitter<void>();
  @Output() sectionDeleted = new EventEmitter<void>();
  @Output() sectionUpdate = new EventEmitter<UpdateReportFeedbackProvidersRequest>();

  constructor(
    private dialogService: DialogService,
    private translocoService: TranslocoService,
  ) {}

  openDialog(sectionUid: string): void {
    if (!sectionUid) {
      this.sectionDeleted.next();
      return;
    }
    this.dialogService
      .showConfirmDialog(this.translocoService.translate('translations.dialog.title.removeSection'), this.translocoService)
      .then((confirmed) => {
        if (confirmed) {
          this.sectionDeleted.next();
        }
      });
  }

  saveTitle(title: string): void {
    const data: UpdateReportFeedbackProvidersRequest = {
      title: title || undefined,
    };

    this.sectionUpdate.emit(data);
  }
}
